'use client';

import { cn } from '@/lib/tailwind';

type Props = {
    checked: boolean;
    disabled?: boolean;
    onChange?: (checked: boolean) => void;
    label: string;
    id?: string;
};

export function ConsentToggle({ checked, disabled, onChange, label, id }: Props) {
    return (
        <button
            type="button"
            role="switch"
            id={id}
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => onChange?.(!checked)}
            className={cn(
                'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors duration-200',
                'focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-500/60',
                checked ? 'bg-primary-500' : 'bg-gray-600',
                disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
            )}
        >
            <span
                className={cn(
                    'inline-block h-4.5 w-4.5 transform rounded-full bg-white shadow transition-transform duration-200',
                    checked ? 'translate-x-5.5' : 'translate-x-1',
                )}
            />
        </button>
    );
}
